module.exports = __webpack_public_path__ + "static/media/gallery-3.6d65b09a.png";